import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WorkflowProcessingState {
  processingAwardGoldBadge: boolean;
}

const initialState: WorkflowProcessingState = {
  processingAwardGoldBadge: false,
};

const workflowProcessingSlice = createSlice({
  name: 'workflowProcessingSlice',
  initialState,
  reducers: {
    setProcessingAwardGoldBadge(state, action: PayloadAction<boolean>) {
      state.processingAwardGoldBadge = action.payload;
    },
  },
});

export const {
  setProcessingAwardGoldBadge,
} = workflowProcessingSlice.actions;

export default workflowProcessingSlice.reducer;
